import React from "react";
import CustomerLogos from "../components/customerlogos";
import DottedLine from "../components/DottedLine";
import FeaturedWork from "../components/FeaturedWork";
import Header from "../components/header";
import Layout from "../components/layout";
import Testimonial from "../components/Testimonial";
import HeatherCircle from "../images/clients/heather-circle.png";

export default function HomePage() {
  return (
    <Layout>
      <Header />
      <div className="container home-dotted-line">
        <DottedLine />
      </div>
      <FeaturedWork />
      <CustomerLogos className="mb-5 pb-5 mt-5 pt-5" />
      <Testimonial
        clientimage={HeatherCircle}
        name="Cristina Hoyt"
        companyname="CristinaHoyt.com"
      >
        Since I had my website updated my sales have gone up 300% with an easy
        to navigate website and integrated SEO. I’ve started to be able to
        attract clients I didn’t know were available.
      </Testimonial>
    </Layout>
  );
}

